import { BubbleMenu } from '@tiptap/react/menus';
import { Button, Space } from 'antd';
import { BoldOutlined, ItalicOutlined, HighlightOutlined } from '@ant-design/icons';
import type { Editor } from '@tiptap/react';
import { useEditorState } from '@tiptap/react';
import LinkPopover from './LinkPopover';

/** 選取文字時浮現的工具列（WordPress 手感）：粗體 / 斜體 / 螢光 / 連結。 */
export default function EditorBubbleMenu({ editor }: { editor: Editor }) {
  const s = useEditorState({
    editor,
    selector: ({ editor: e }) => ({
      bold: e.isActive('bold'),
      italic: e.isActive('italic'),
      highlight: e.isActive('highlight'),
      link: e.isActive('link'),
    }),
  });
  const c = () => editor.chain().focus();

  return (
    <BubbleMenu
      editor={editor}
      options={{ placement: 'top' }}
      shouldShow={({ editor: e, from, to }) => from !== to && !e.isActive('image')}
    >
      <div className="rounded-md border border-gray-200 bg-white px-1 py-1 shadow-lg">
        <Space size={2}>
          <Button size="small" type={s.bold ? 'primary' : 'text'} icon={<BoldOutlined />} onClick={() => c().toggleBold().run()} />
          <Button size="small" type={s.italic ? 'primary' : 'text'} icon={<ItalicOutlined />} onClick={() => c().toggleItalic().run()} />
          <Button size="small" type={s.highlight ? 'primary' : 'text'} icon={<HighlightOutlined />} onClick={() => c().toggleHighlight().run()} />
          <LinkPopover editor={editor} active={s.link} />
        </Space>
      </div>
    </BubbleMenu>
  );
}
